import Text from '@components/Text/Text';
import { styled, Switch } from '@mui/material';

export const StyledToggle = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 17,
  padding: 0,
  marginLeft: theme.spacing(9),
  marginRight: theme.spacing(9),
  '& .MuiSwitch-switchBase': {
    padding: 0,
    transitionDuration: '300ms',
    color: theme.palette.primary.main,
    opacity: 1,
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: theme.palette.primary.main,
      opacity: 1,
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary[200],
        opacity: 1,
      },
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 1,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: theme.spacing(9),
    height: theme.spacing(9),
  },
  '& .MuiSwitch-track': {
    borderRadius: theme.spacing(9),
    backgroundColor: theme.palette.primary[200],
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

export const FirstLabel = styled(Text, {
  shouldForwardProp: (props) => props !== 'checked',
})<{ checked: boolean }>(({ theme, checked }) => ({
  color: !checked ? theme.palette.primary.main : theme.palette.grey.A100,
  width: '40%',
}));

export const SecondLabel = styled(Text, {
  shouldForwardProp: (props) => props !== 'checked',
})<{ checked: boolean }>(({ theme, checked }) => ({
  color: checked ? theme.palette.primary.main : theme.palette.grey.A100,
  width: '40%',
  textAlign: 'end',
}));
